import React from "react";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import SendIcon from "@mui/icons-material/Send";
import GraphicEqOutlinedIcon from "@mui/icons-material/GraphicEqOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import OpenInFullOutlinedIcon from "@mui/icons-material/OpenInFullOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";

const AIAssistantPanel = ({
  aiMode,
  setAiMode,
  aiInput,
  setAiInput,
  isRecording,
  setIsRecording,
}) => {
  if (!aiMode) return null;

  const handleSubmit = () => {
    if (aiInput.trim()) {
      console.log("AI Query:", aiInput);
      setAiInput("");
    }
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: 20,
        left: "50%",
        transform: "translateX(-50%)",
        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: 3,
        zIndex: 1000,
        minWidth: "1000px",
        maxWidth: "1200px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          bgcolor: "#112138",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SmartToyOutlinedIcon fontSize="small" />
          <Typography variant="subtitle2" fontWeight={600}>
            Virbrix AI Assistant
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton
          size="small"
          sx={{
            color: "#fff",
            "&:hover": { bgcolor: "rgba(255, 255, 255, 0.1)" },
          }}
        >
          <OpenInFullOutlinedIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          sx={{
            color: "#fff",
            "&:hover": { bgcolor: "rgba(255, 255, 255, 0.1)" },
          }}
          onClick={() => setAiMode(false)}
        >
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          p: 1,
        }}
      >
        <TextField
          fullWidth
          multiline
          maxRows={4}
          placeholder="Ask Virbrix AI Assistant about anything"
          value={aiInput}
          onChange={(e) => setAiInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: isRecording ? "#112138" : "transparent",
                    color: isRecording ? "#fff" : "#666",
                    "&:hover": {
                      bgcolor: "#112138",
                      color: "#fff",
                    },
                    animation: isRecording ? "pulse 1.5s infinite" : "none",
                    "@keyframes pulse": {
                      "0%, 100%": { opacity: 1 },
                      "50%": { opacity: 0.6 },
                    },
                  }}
                  onClick={() => setIsRecording(!isRecording)}
                >
                  <MicIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  sx={{
                    color: "#112138",
                    "&:hover": {
                      bgcolor: "#112138",
                      color: "#fff",
                    },
                  }}
                  onClick={handleSubmit}
                  disabled={!aiInput.trim()}
                >
                  <SendIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              color: "#000",
              bgcolor: "#fff",
            },
          }}
        />

        <IconButton
          size="small"
          sx={{
            bgcolor: "#fff",
            color: "#000",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            "&:hover": {
              bgcolor: "#112138",
              color: "#fff",
            },
            "&:active": {
              bgcolor: "#112138",
              color: "#fff",
            },
          }}
        >
          <GraphicEqOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default AIAssistantPanel;